import merge from 'lodash/merge'
import defaultTypography from '../typography'

export const FONTS = {
  REGULAR: '"Nunito Sans", Helvetica, Arial, sans-serif',
  BOLD: '"Onest", Helvetica, Arial, sans-serif',
  SEMI_BOLD: '"Nunito Sans", Helvetica, Arial, sans-serif',
  TITLE: '"Onest", Helvetica, Arial, sans-serif',
}

export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  info: '#F40F97',
  success: '#27F590',
  error: '#FF0F00',
  warning: '#F5D30F',
  pink: '#F40F97',
  pinkDarker: '#8E0456',
  greyDark: '#545454',
  greyMedium: '#A9A9A9',
  disabled: '#CCCCCC',
  mauve: '#E6DFE4',
}

export const typography = merge({}, defaultTypography, {
  heading: {
    large: {
      color: COLORS.black,
      fontFamily: FONTS.TITLE,
    },
    small: {
      color: COLORS.black,
      fontFamily: FONTS.TITLE,
    },
    subheading: {
      color: COLORS.black,
      fontFamily: FONTS.TITLE,
    },
  },
  copy: {
    title: {
      color: COLORS.black,
      fontFamily: FONTS.REGULAR,
      fontWeight: 600,
    },
    body: {
      color: COLORS.greyDark,
      fontWeight: 600,
      fontFamily: FONTS.REGULAR,
    },
    bodyBold: {
      color: COLORS.greyDark,
      fontFamily: FONTS.BOLD,
    },
    bodyFaint: {
      color: COLORS.greyMedium,
      fontFamily: FONTS.REGULAR,
    },
    tiny: {
      color: COLORS.greyDark,
      fontFamily: FONTS.REGULAR,
    },
    tinyFaint: {
      color: COLORS.greyMedium,
      fontFamily: FONTS.REGULAR,
    },
    tinyBold: {
      color: COLORS.greyDark,
      fontFamily: FONTS.REGULAR,
    },
  },
  label: {
    color: COLORS.pink,
    fontFamily: FONTS.SEMI_BOLD,
  },
  optional: {
    color: COLORS.greyMedium,
    fontFamily: FONTS.REGULAR,
  },
})
